import { ContentSolid } from '@octopus-do/octopus-storybook/icons'
import type React from 'react'

import { clsJoin } from '@/utils'
import css from './styles.module.css'

interface Props {
  className: string
}

export const EmptyState: React.FC<Props> = ({ className }) => (
  <div className={clsJoin(className, css.empty_state, 'empty_state')}>
    <ContentSolid className={css.icon} />
  </div>
)
